import { combineReducers } from "redux";
import masterDataReducer from "./masterData/reducer";
import dashboardReducer from "./dashboard/reducer";
import activityLogReducer from "./activityLogs/reducer";
import usersReducer from "./users/reducer";
import configurationReducer from "./configuration/reducer";
import ltlCustomerReducer from "./ltlCustomers/reducer";
import invoiceReducer from "./invoicesEntry/reducer";
import customersVendorsReducer from "./customersVendors/reducer";
import { RESET_ON_LOGOUT } from "./users/actionTypes";
import piaggioCustomerReducer from "./piaggioCustomers/reducer";
import piaggioItemDetailsReducer from "./piaggioItemDetails/reducer";
import lozierStoreReducer from "./lozierStore/reducer";
import allCustomersVendorsReducer from "./allCustomersVendors/reducer";
import allUsersReducer from "./allUsers/reducer";
import ecolabItemDetailsReducer from "./ecolabItemDetails/reducer";
import podDocumentReducer from "./podDocument/reducer";
import cardtronicsCustomerReducer from "./cardtronicsCustomers/reducer";
import hpeCustomerReducer from "./hpeCustomers/reducer";
import calixNetworksCustomerReducer from "./calixNetworksCustomers/reducer";
import nautilusItemDetailsReducer from "./nautilusItemDetails/reducer";
import settingsReducer from "./settings/reducer";
import carrierTrackingReducer from "./carrierTracking/reducer";

const appReducer = combineReducers({
  masterData: masterDataReducer,
  dashboard: dashboardReducer,
  activityLog: activityLogReducer,
  users: usersReducer,
  configuration: configurationReducer,
  ltlCustomer: ltlCustomerReducer,
  invoices: invoiceReducer,
  customersVendors: customersVendorsReducer,
  allCustomersVendors: allCustomersVendorsReducer,
  piaggioCustomer: piaggioCustomerReducer,
  piaggioItemDetails: piaggioItemDetailsReducer,
  ecolabItemDetails: ecolabItemDetailsReducer,
  lozierStore: lozierStoreReducer,
  allUsersReducer: allUsersReducer,
  podDocument: podDocumentReducer,
  cardtronicsCustomer: cardtronicsCustomerReducer,
  hpeCustomer: hpeCustomerReducer,
  calixNetworksCustomer: calixNetworksCustomerReducer,
  nautilusItemDetails: nautilusItemDetailsReducer,
  settings: settingsReducer,
  carrierTracking: carrierTrackingReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_ON_LOGOUT) {
    state = {
      masterData: undefined,
      dashboard: undefined,
      activityLog: undefined,
      users: undefined,
      configuration: undefined,
      ltlCustomer: undefined,
      invoices: undefined,
      customersVendors: undefined,
      allCustomersVendors: undefined,
      piaggioCustomer: undefined,
      piaggioItemDetails: undefined,
      ecolabItemDetails: undefined,
      lozierStore: undefined,
      allUsersReducer: undefined,
      podDocument: undefined,
      cardtronicsCustomer: undefined,
      calixNetworksCustomer: undefined,
      nautilusItemDetails: undefined,
      settings: undefined,
      carrierTracking: undefined,
    };
  }
  return appReducer(state, action);
};

export type AuthState = ReturnType<typeof rootReducer>;

export default rootReducer;
